export function enablePersistentCache(get) {
    const s = get();
    if (typeof s.cache === 'string')
        s.cache = new Date(s.cache);
}
//# sourceMappingURL=enablePersistentCache.js.map